// extracted by mini-css-extract-plugin
export default {"App":"DashboardCard_App__cFPya","card":"DashboardCard_card__aXg61","box":"DashboardCard_box__2j9W6","content":"DashboardCard_content__L3nQO"};